<template>
  <coozzy-card :title="$t('message.settings.ticketing.informationTickets')">
    <p>
      {{ $t('message.settings.ticketing.subTitle') }}
    </p>
    <div
      v-if="loading"
      style="height: 30px">
      <coozzy-spinner />
    </div>
    <div v-else>
      <template v-if="showAdminBaseTicketingSections">
        <!--   Insurance   -->
        <coozzy-card class="global-card">
          <div
            v-b-toggle="`collapse-ticketing-insurance`"
            class="collapse-title">
            <h5 class="cursor-pointer">
              {{ $t('message.onBoarding.createBuilding.insurance') }}
            </h5>
          </div>
          <b-collapse
            v-if="insurance_expire"
            :id="`collapse-ticketing-insurance`"
            :visible="true">
            <information-ticket-item
              ref="insurance_expire"
              :list-employee="listAllEmployees"
              :schedule="insurance_expire"
              @schedule-updated="scheduleUpdated" />
          </b-collapse>
        </coozzy-card>
        <!--   Mortgage   -->
        <coozzy-card class="global-card">
          <div
            v-b-toggle="`collapse-ticketing-mortgage`"
            class="collapse-title">
            <h5 class="cursor-pointer">
              {{ $t('message.onBoarding.createBuilding.mortgage') }}
            </h5>
          </div>
          <b-collapse
            v-if="mortgage_expire"
            :id="`collapse-ticketing-mortgage`"
            :visible="true">
            <information-ticket-item
              ref="mortgage_expire"
              :list-employee="listAllEmployees"
              :schedule="mortgage_expire"
              @schedule-updated="scheduleUpdated" />
          </b-collapse>
        </coozzy-card>
        <!--   Building strategy   -->
        <coozzy-card class="global-card">
          <div
            v-b-toggle="`collapse-ticketing-building`"
            class="collapse-title">
            <h5 class="cursor-pointer">
              {{ $t('message.generic.building') }}
            </h5>
          </div>
          <b-collapse
            v-if="building_strategy_revise"
            :id="`collapse-ticketing-building`"
            :visible="true">
            <information-ticket-item
              ref="building_strategy_revise"
              :list-employee="listAllEmployees"
              :schedule="building_strategy_revise"
              @schedule-updated="scheduleUpdated" />
          </b-collapse>
        </coozzy-card>
        <!--   Device   -->
        <coozzy-card class="global-card">
          <div
            v-b-toggle="`collapse-ticketing-device`"
            class="collapse-title">
            <h5 class="cursor-pointer">
              {{ $t('message.onBoarding.devices.title') }}
            </h5>
          </div>
          <b-collapse
            v-if="device_warranty_expire && device_maintenance_expire && device_inspection_expire && device_revision_expire"
            :id="`collapse-ticketing-device`"
            :visible="true">
            <information-ticket-item
              ref="device_warranty_expire"
              :list-employee="listAllEmployees"
              :schedule="device_warranty_expire"
              @schedule-updated="scheduleUpdated" />
            <information-ticket-item
              ref="device_maintenance_expire"
              :list-employee="listAllEmployees"
              :schedule="device_maintenance_expire"
              @schedule-updated="scheduleUpdated" />
            <information-ticket-item
              ref="device_inspection_expire"
              :list-employee="listAllEmployees"
              :schedule="device_inspection_expire"
              @schedule-updated="scheduleUpdated" />
            <information-ticket-item
              ref="device_revision_expire"
              :list-employee="listAllEmployees"
              :schedule="device_revision_expire"
              @schedule-updated="scheduleUpdated" />
            <information-ticket-item
              ref="device_maintenance_next"
              :list-employee="listAllEmployees"
              :schedule="device_maintenance_next"
              @schedule-updated="scheduleUpdated" />
            <information-ticket-item
              ref="device_inspection_next"
              :list-employee="listAllEmployees"
              :schedule="device_inspection_next"
              @schedule-updated="scheduleUpdated" />
            <information-ticket-item
              ref="device_revision_next"
              :list-employee="listAllEmployees"
              :schedule="device_revision_next"
              @schedule-updated="scheduleUpdated" />
          </b-collapse>
        </coozzy-card>
        <!--   Tenancies   -->
        <coozzy-card class="global-card">
          <div
            v-b-toggle="`collapse-ticketing-tenancies`"
            class="collapse-title">
            <h5 class="cursor-pointer">
              {{ $t('message.onBoarding.buildings.objects.tenancies.title') }}
            </h5>
          </div>
          <b-collapse
            v-if="tenancy_fixed_term_ends && tenancy_option_expire"
            :id="`collapse-ticketing-tenancies`"
            :visible="true">
            <information-ticket-item
              ref="tenancy_fixed_term_ends"
              :list-employee="listAllEmployees"
              :schedule="tenancy_fixed_term_ends"
              @schedule-updated="scheduleUpdated" />
            <information-ticket-item
              ref="tenancy_terminated"
              :list-employee="listAllEmployees"
              :schedule="tenancy_terminated"
              @schedule-updated="scheduleUpdated" />
            <information-ticket-item
              ref="tenancy_option_expire"
              :list-employee="listAllEmployees"
              :schedule="tenancy_option_expire"
              @schedule-updated="scheduleUpdated" />
            <information-ticket-item
              ref="tenancy_early_right_of_termination"
              :list-employee="listAllEmployees"
              :schedule="tenancy_early_right_of_termination"
              @schedule-updated="scheduleUpdated" />
            <information-ticket-item
              ref="tenancy_deposit_due_date"
              :list-employee="listAllEmployees"
              :schedule="tenancy_deposit_due_date"
              @schedule-updated="scheduleUpdated" />
            <information-ticket-item
              ref="tenancy_deposit_bank_guarantee"
              :list-employee="listAllEmployees"
              :schedule="tenancy_deposit_bank_guarantee"
              @schedule-updated="scheduleUpdated" />
          </b-collapse>
        </coozzy-card>
      </template>
      <!--   Requests (digital reference check)   -->
      <coozzy-card class="global-card">
        <div
          v-b-toggle="`collapse-ticketing-requests`"
          class="collapse-title">
          <h5 class="cursor-pointer">
            {{ $t('message.settings.ticketing.requests') }}
          </h5>
        </div>
        <b-collapse
          v-if="employer_reference_email && landlord_reference_email"
          :id="`collapse-ticketing-requests`"
          :visible="true">
          <information-ticket-item
            ref="employer_reference_email"
            :list-employee="listAllEmployees"
            :schedule="employer_reference_email"
            @schedule-updated="scheduleUpdated" />
          <information-ticket-item
            ref="landlord_reference_email"
            :list-employee="listAllEmployees"
            :schedule="landlord_reference_email"
            @schedule-updated="scheduleUpdated" />
        </b-collapse>
      </coozzy-card>
      <!--   MARKETbase   -->
      <coozzy-card class="global-card">
        <div
          v-b-toggle="`collapse-ticketing-marketbase`"
          class="collapse-title">
          <h5 class="cursor-pointer">
            {{ $t('message.settings.ticketing.marketbase') }}
          </h5>
        </div>
        <b-collapse
          v-if="scheduler_requested_appointments_missing"
          :id="`collapse-ticketing-marketbase`"
          :visible="true">
          <information-ticket-item
            ref="scheduler_requested_appointments_missing"
            :list-employee="listAllEmployees"
            :schedule="scheduler_requested_appointments_missing"
            @schedule-updated="scheduleUpdated" />
        </b-collapse>
      </coozzy-card>
    </div>
    <div class="col">
      <coozzy-button
        class="float-right mt-2"
        design="green"
        @click="saveSettings">
        {{ $t('message.generic.form.save') }}
      </coozzy-button>
    </div>
  </coozzy-card>
</template>
<script>
import CoozzyCard from '../../framework/components/card/CoozzyCard'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner'
import { user } from '@/mixins/user'
import { routeChecks } from '@/mixins/routeChecks'
import TicketApi from '@/misc/apis/TicketApi'
import Vue from 'vue'
import UserApi from '@/misc/apis/UserApi'
import { mapActions, mapGetters } from 'vuex'
import InformationTicketItem from '@/settings/components/InformationTicketItem.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'

export default {
  name: 'TicketingSettings',
  components: {
    CoozzyButton,
    InformationTicketItem,
    CoozzySpinner,
    CoozzyCard
  },
  mixins: [user, routeChecks],
  data() {
    return {
      loading: false,
      schedule: {
        accountId: '',
        assigneeUserId: '',
        category: '',
        createAtAmount: 0,
        createAtUnit: 'SCHEDULE_UNIT_UNDEFINED',
        dueDateAmount: 0,
        dueDateUnit: 'SCHEDULE_UNIT_UNDEFINED',
        enabled: false,
        language: 'PREFERRED_LANGUAGE_UNDEFINED',
        useObjectAssignee: false
      },
      insurance_expire: null,
      mortgage_expire: null,
      building_strategy_revise: null,
      device_warranty_expire: null,
      device_maintenance_expire: null,
      device_inspection_expire: null,
      device_revision_expire: null,
      tenancy_fixed_term_ends: null,
      tenancy_option_expire: null,
      tenancy_early_right_of_termination: null,
      tenancy_deposit_due_date: null,
      tenancy_deposit_bank_guarantee: null,
      tenancy_terminated: null,
      device_maintenance_next: null,
      device_inspection_next: null,
      device_revision_next: null,
      scheduler_requested_appointments_missing: null,
      employer_reference_email: null,
      landlord_reference_email: null,
      categoriesLoadedFromApi: [],
      currentEmployeeList: [],
      listAllEmployees: [],
      ownerAccounts: [],
      listCategories: [
        'insurance_expire',
        'mortgage_expire',
        'building_strategy_revise',
        'device_warranty_expire',
        'device_maintenance_expire',
        'device_inspection_expire',
        'device_revision_expire',
        'device_inspection_next',
        'device_maintenance_next',
        'device_revision_next',
        'tenancy_fixed_term_ends',
        'tenancy_option_expire',
        'tenancy_early_right_of_termination',
        'tenancy_deposit_due_date',
        'tenancy_deposit_bank_guarantee',
        'tenancy_terminated',
        'scheduler_requested_appointments_missing',
        'employer_reference_email',
        'landlord_reference_email'
      ]
    }
  },
  computed: {
    showAdminBaseTicketingSections() {
      return this.isAdminModule || (this.isMarketingModule && this.hasAccessAdminBase)
    },
    employeeList() {
      if (this.getEmployees().length > 0) {
        return this.getEmployees().filter(x => !x.blocked)
      }
      return []
    }
  },
  mounted: function () {
    this.loading = true
    this.loadEmployees()
    this.getSchedules()
    this.getListEmployees([this.accountId])
  },
  methods: {
    ...mapActions('employee', ['loadEmployees']),
    ...mapGetters('employee', ['getEmployees']),
    saveSettings() {
      const insuranceExpireInvalid = this.$refs.insurance_expire && this.$refs.insurance_expire.isInvalid()
      const mortgageExpireInvalid = this.$refs.mortgage_expire && this.$refs.mortgage_expire.isInvalid()
      const buildingStrategyReviseInvalid = this.$refs.building_strategy_revise && this.$refs.building_strategy_revise.isInvalid()
      const deviceWarrantyExpireInvalid = this.$refs.device_warranty_expire && this.$refs.device_warranty_expire.isInvalid()
      const deviceMaintenanceExpireInvalid = this.$refs.device_maintenance_expire && this.$refs.device_maintenance_expire.isInvalid()
      const deviceInspectionExpireInvalid = this.$refs.device_inspection_expire && this.$refs.device_inspection_expire.isInvalid()
      const deviceRevisionExpireInvalid = this.$refs.device_revision_expire && this.$refs.device_revision_expire.isInvalid()
      const deviceMaintenanceNextInvalid = this.$refs.device_maintenance_next && this.$refs.device_maintenance_next.isInvalid()
      const deviceInspectionNextInvalid = this.$refs.device_inspection_next && this.$refs.device_inspection_next.isInvalid()
      const deviceRevisionNextInvalid = this.$refs.device_revision_next && this.$refs.device_revision_next.isInvalid()
      const tenancyFixedTermEndsInvalid = this.$refs.tenancy_fixed_term_ends && this.$refs.tenancy_fixed_term_ends.isInvalid()
      const tenancyOptionExpireInvalid = this.$refs.tenancy_option_expire && this.$refs.tenancy_option_expire.isInvalid()
      const tenancyEarlyRightOfTerminationInvalid = this.$refs.tenancy_early_right_of_termination && this.$refs.tenancy_early_right_of_termination.isInvalid()
      const tenancyDepositDueDate = this.$refs.tenancy_deposit_due_date && this.$refs.tenancy_deposit_due_date.isInvalid()
      const tenancyDepositBankGuarantee = this.$refs.tenancy_deposit_bank_guarantee && this.$refs.tenancy_deposit_bank_guarantee.isInvalid()
      const tenancyTerminatedInvalid = this.$refs.tenancy_terminated && this.$refs.tenancy_terminated.isInvalid()
      const schedulerRequestedAppointmentsMissingInvalid = this.$refs.scheduler_requested_appointments_missing && this.$refs.scheduler_requested_appointments_missing.isInvalid()
      const employerReferenceEmailInvalid = this.$refs.employer_reference_email && this.$refs.employer_reference_email.isInvalid()
      const landlordReferenceEmailInvalid = this.$refs.landlord_reference_email && this.$refs.landlord_reference_email.isInvalid()

      if (insuranceExpireInvalid || mortgageExpireInvalid || buildingStrategyReviseInvalid || deviceWarrantyExpireInvalid ||
        deviceMaintenanceExpireInvalid || deviceInspectionExpireInvalid || deviceRevisionExpireInvalid || tenancyFixedTermEndsInvalid ||
        tenancyOptionExpireInvalid || tenancyDepositDueDate || deviceMaintenanceNextInvalid || deviceInspectionNextInvalid || deviceRevisionNextInvalid || tenancyDepositBankGuarantee || tenancyEarlyRightOfTerminationInvalid || tenancyTerminatedInvalid || schedulerRequestedAppointmentsMissingInvalid ||
        employerReferenceEmailInvalid || landlordReferenceEmailInvalid) {
        Vue.toasted.show(this.$tc('message.savingErrors.mandatoryMissing'), { type: 'error' })
      } else {
        this.loading = true
        const schedules = []
        const pushIfPersistable = (schedule) => {
          if (schedule && this.shouldPersistSchedule(schedule.category)) {
            schedules.push(schedule)
          }
        }
        pushIfPersistable(this.insurance_expire)
        pushIfPersistable(this.mortgage_expire)
        pushIfPersistable(this.building_strategy_revise)
        pushIfPersistable(this.device_warranty_expire)
        pushIfPersistable(this.device_maintenance_expire)
        pushIfPersistable(this.device_inspection_expire)
        pushIfPersistable(this.device_revision_expire)
        pushIfPersistable(this.device_maintenance_next)
        pushIfPersistable(this.device_inspection_next)
        pushIfPersistable(this.device_revision_next)
        pushIfPersistable(this.tenancy_fixed_term_ends)
        pushIfPersistable(this.tenancy_option_expire)
        pushIfPersistable(this.tenancy_early_right_of_termination)
        pushIfPersistable(this.tenancy_deposit_due_date)
        pushIfPersistable(this.tenancy_deposit_bank_guarantee)
        pushIfPersistable(this.tenancy_terminated)
        pushIfPersistable(this.scheduler_requested_appointments_missing)
        pushIfPersistable(this.employer_reference_email)
        pushIfPersistable(this.landlord_reference_email)
        TicketApi.setSchedules(schedules).then(() => {
          this.loading = false
          this.getSchedules()
        }).catch((error) => {
          this.loading = false
          console.log(error)
        })
      }
    },
    createDefaultSchedule(category) {
      this.schedule.accountId = this.accountId
      const defaultSchedule = JSON.parse(JSON.stringify(this.schedule))
      defaultSchedule.category = category
      return defaultSchedule
    },
    shouldPersistSchedule(category) {
      if (['scheduler_requested_appointments_missing', 'employer_reference_email', 'landlord_reference_email'].includes(category)) {
        return true
      }
      if (this.showAdminBaseTicketingSections) {
        return true
      }
      return this.categoriesLoadedFromApi.includes(category)
    },
    applyScheduleByCategory(schedule) {
      if (!schedule || !schedule.category || !this.listCategories.includes(schedule.category)) {
        return
      }
      this[schedule.category] = schedule
    },
    initializeDefaultSchedules() {
      this.categoriesLoadedFromApi = []
      this.listCategories.forEach((category) => {
        this[category] = this.createDefaultSchedule(category)
      })
    },
    getSchedules() {
      TicketApi.listSchedules(this.accountId)
        .then((response) => {
          const schedules = Array.isArray(response?.schedules) ? response.schedules : []
          this.categoriesLoadedFromApi = schedules
            .map(schedule => schedule?.category)
            .filter(category => this.listCategories.includes(category))
          if (schedules.length > 0) {
            schedules.forEach((schedule) => this.applyScheduleByCategory(schedule))
            this.checkMissingCategories()
          } else {
            this.initializeDefaultSchedules()
          }
        })
        .catch((error) => {
          console.error('Unable to load ticketing schedules', error)
          this.initializeDefaultSchedules()
        })
        .finally(() => {
          this.loading = false
        })
    },
    scheduleUpdated(schedule) {
      if (['unassigned', 'assigneeObject'].includes(schedule.assigneeUserId)) {
        schedule.useObjectAssignee = schedule.assigneeUserId === 'assigneeObject'
        schedule.assigneeUserId = ''
      } else {
        schedule.useObjectAssignee = false
      }
      switch (schedule.category) {
        case 'insurance_expire':
          this.insurance_expire = schedule
          break
        case 'mortgage_expire':
          this.mortgage_expire = schedule
          break
        case 'building_strategy_revise':
          this.building_strategy_revise = schedule
          break
        case 'device_warranty_expire':
          this.device_warranty_expire = schedule
          break
        case 'device_maintenance_expire':
          this.device_maintenance_expire = schedule
          break
        case 'device_inspection_expire':
          this.device_inspection_expire = schedule
          break
        case 'device_revision_expire':
          this.device_revision_expire = schedule
          break
        case 'device_maintenance_next':
          this.device_maintenance_next = schedule
          break
        case 'device_inspection_next':
          this.device_inspection_next = schedule
          break
        case 'device_revision_next':
          this.device_revision_next = schedule
          break
        case 'tenancy_fixed_term_ends':
          this.tenancy_fixed_term_ends = schedule
          break
        case 'tenancy_option_expire':
          this.tenancy_option_expire = schedule
          break
        case 'tenancy_early_right_of_termination':
          this.tenancy_early_right_of_termination = schedule
          break
        case 'tenancy_deposit_due_date':
          this.tenancy_deposit_due_date = schedule
          break
        case 'tenancy_deposit_bank_guarantee':
          this.tenancy_deposit_bank_guarantee = schedule
          break
        case 'tenancy_terminated':
          this.tenancy_terminated = schedule
          break
        case 'scheduler_requested_appointments_missing':
          this.scheduler_requested_appointments_missing = schedule
          break
        case 'employer_reference_email':
          this.employer_reference_email = schedule
          break
        case 'landlord_reference_email':
          this.landlord_reference_email = schedule
          break
      }
    },
    checkMissingCategories() {
      this.listCategories.forEach((category) => {
        if (this[category] === null) {
          this[category] = this.createDefaultSchedule(category)
        }
      })
    },
    getListEmployees(listIds) {
      if (listIds.length > 0) {
        TicketApi.listTicketingEnabled(listIds)
          .then(rsp => {
            const enabledAccountIds = Array.isArray(rsp?.enabledAccountIds) ? rsp.enabledAccountIds : []
            if (enabledAccountIds.length === 0) {
              this.addAvailableEmployees()
              return
            }
            UserApi.listAllEmployees(enabledAccountIds).then(response1 => {
              this.currentEmployeeList = response1.employees
              if (this.currentEmployeeList.length > 0) {
                const ids = [...new Set(this.currentEmployeeList.map(x => x.accountId).concat(this.employeeList.map(x => x.accountId)))]
                if (ids.length > 0) {
                  UserApi.listAccountsByIds(ids)
                    .then(accounts => {
                      this.ownerAccounts = accounts.accounts
                      this.addAvailableEmployees()
                    })
                    .catch((error) => {
                      console.error('Unable to load owner accounts for ticketing assignees', error)
                      this.addAvailableEmployees()
                    })
                } else {
                  this.addAvailableEmployees()
                }
              } else {
                this.addAvailableEmployees()
              }
            }).catch((error) => {
              console.error('Unable to load ticketing-enabled employees', error)
              this.addAvailableEmployees()
            })
          })
          .catch((error) => {
            console.error('Unable to load ticketing-enabled account IDs', error)
            this.addAvailableEmployees()
          })
      }
    },
    addAvailableEmployees() {
      const array = []
      if (this.employeeList.length !== 0) {
        this.employeeList.filter(x => (x.blocked === false && x.deleted === false)).forEach((employee) => {
          const accountName = this.ownerAccounts.find(x => x.id === employee.accountId)
          array.push({
            label: (employee.profile.firstName ? employee.profile.firstName + ' ' : '') + employee.profile.lastName,
            value: employee,
            company: (accountName ? ' ' + (accountName.company ? accountName.company?.name : accountName.individual.firstName + ' ' + accountName.individual.lastName) : '')
          })
        })
      }
      if (this.currentEmployeeList.length !== 0) {
        this.currentEmployeeList.filter(x => (x.blocked === false && x.deleted === false)).forEach((employee) => {
          const accountName = this.ownerAccounts.find(x => x.id === employee.accountId)
          array.push({
            label: ((employee.profile.firstName ? employee.profile.firstName + ' ' : '') + employee.profile.lastName),
            value: employee,
            company: (accountName ? ' ' + (accountName.company ? accountName.company?.name : accountName.individual.firstName + ' ' + accountName.individual.lastName) : '')
          })
        })
      }
      const ids = array.map(o => o.value.id)
      const filtered = array.filter(({ value }, index) => !ids.includes(value.id, index + 1))
      const accountUsers = filtered.filter(x => parseInt(x.value.accountId) === this.accountId).sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1))
      const otherUsers = filtered.filter(x => parseInt(x.value.accountId) !== this.accountId).sort((a, b) => (a.company > b.company ? 1 : -1))
      this.listAllEmployees = accountUsers.concat(otherUsers)
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
